export const CUSTOMER_DASHBOARD_TOUR_STEPS = [
  {
    selector: '#cd-main-dashboard-tab',
    placement: 'bottom',
    title: 'Welcome to your Account Dashboard',
    content: "Use this button anytime to jump back to your Main Dashboard.",
  },
  {
    selector: '#cd-header',
    placement: 'bottom',
    title: 'Account overview',
    content: 'Your organization name, contract renewal date, and account owner contact — all at a glance.',
  },
  {
    selector: '#cd-export-button',
    placement: 'bottom',
    title: 'Export your data',
    content: 'Download everything on this page as a PDF or CSV whenever you need to share it with your team.',
  },
  {
    selector: '#cd-usage-metrics',
    placement: 'bottom',
    title: 'Usage metrics',
    content: 'Track how many videos and quick turns you’ve used against your contract limits.',
  },
  {
    selector: '#cd-project-status',
    placement: 'bottom',
    title: 'Current project status',
    content: 'See how many of your videos are in each stage of production, from pre-production through to complete.',
  },
  {
    selector: '#cd-monthly-chart',
    placement: 'top',
    title: 'Monthly output',
    content: 'Visualize videos delivered each month. Use the From/To filters to explore a custom date range.',
  },
  {
    selector: '#cd-team-chart',
    placement: 'top',
    title: 'Team breakdown',
    content: 'See how your video output is distributed across your team members.',
  },
  {
    selector: '#cd-contract-sidebar',
    placement: 'left',
    title: 'Contract details',
    content: 'Your plan type, renewal date, and video/quick-turn credit limits, all in one place.',
  },
  {
    selector: '#cd-video-types-chart',
    placement: 'left',
    title: 'Video types',
    content: 'A breakdown of the kinds of videos you’ve requested most.',
  },
  {
    selector: '#cd-quick-turn-rules',
    placement: 'left',
    title: 'Quick turn rules',
    content: 'A quick reminder of what qualifies as a 24-hour quick turn request.',
  },
  {
    selector: '#cd-support-fab',
    placement: 'top',
    title: 'Need help?',
    content: 'Reach our support team anytime from this button.',
  },
];
